import React from 'react'

import { useSelectedIncidents } from '../hooks'
import { useBufferEditorIsOpen } from '../../buffers/hooks'

import IncidentList from './IncidentList'
import IncidentDetailsPanel from './IncidentDetailsPanel'
import EditForm from '../../buffers/components/EditForm'

const IncidentPanel = () => {
  const editorIsOpen = useBufferEditorIsOpen()
  const [{ current }] = useSelectedIncidents()

  if (editorIsOpen) return <EditForm />
  if (current) return <IncidentDetailsPanel />
  return <IncidentList />
}
export default IncidentPanel
